import React from "react";
import { Menu, Icon, Loader, Label } from "semantic-ui-react";

const ReportsList = (props) => {
  return (
    <Menu vertical fluid pointing compact>
      <Menu.Item>
        <Menu.Header>
          {props.title || (
            <span>
              <Icon name="chart area" color="blue" /> My Reports
            </span>
          )}
        </Menu.Header>
      </Menu.Item>

      {props.reports.length ? (
        <React.Fragment>
          {props.reports.map((item, index) => {
            return (
              <Menu.Item
                key={index}
                name={item.name}
                active={props.selected?.id === item.id}
                onClick={() => props.onSelection(item)}
              >
                {item.name}
                {item.reports && <Label>{item.reports.length}</Label>}
                {props.onFavourite && (
                  <Icon
                    onClick={(e) => {
                      e.stopPropagation();
                      props.onFavourite(item);
                    }}
                    disabled={props.loading}
                    name={item.isFavourited ? "heart" : "heart outline"}
                  />
                )}
                {props.selected === item.id && props.loading && (
                  <Loader
                    active
                    inline
                    size="tiny"
                    style={{ float: "right" }}
                  />
                )}
              </Menu.Item>
            );
          })}
        </React.Fragment>
      ) : (
        <Menu.Item>No reports available.</Menu.Item>
      )}
    </Menu>
  );
};

export default ReportsList;
